var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01372 0C8.62958 0 8.24545 0.207422 8.04664 0.625781L5.84629 5.28047L0.923289 6.02578C0.0404513 6.15937 -0.313358 7.29492 0.326868 7.94531L3.88854 11.5664L3.04614 16.6816C2.89451 17.5992 3.82115 18.2988 4.60964 17.8664L9.01372 15.4547V0Z",
    fill: "#F97316"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95747 0C9.34161 0 9.72575 0.207422 9.92455 0.625781L12.1249 5.28047L17.0479 6.02578C17.9307 6.15937 18.2845 7.29492 17.6443 7.94531L14.0826 11.5664L14.925 16.6816C15.0767 17.5992 14.15 18.2988 13.3616 17.8664L8.95747 15.4547V0Z",
    fill: "#F97316"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar);
export default __webpack_public_path__ + "static/media/rating_star.45b0fcfa54d970c94e8482fbc9428b29.svg";
export { ForwardRef as ReactComponent };